<template>
  <el-card>
    <el-row :gutter="24">
      <el-col :span="4">
        <el-button type="primary" size="default" @click="handleInsertClick()">录入</el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" border style="width: 100%;margin-bottom: 10px;margin-top: 10px" height="72vh"
    >
      <el-table-column label="#" type="index" />
      <el-table-column prop="belongProductId" label="产品" width="160px">
        <template v-slot="scope">
          {{ getProductInfoById(scope.row.belongProduct)  }}
        </template>
      </el-table-column>
      <el-table-column prop="entity" label="转账主体">
      </el-table-column>
      <el-table-column prop="bank" label="开户行">
    </el-table-column>
      <el-table-column prop="bankAccount" label="银行账号">
      </el-table-column>
      <el-table-column prop="operatorTime" label="添加时间">
        <template v-slot="scope">
          {{ $filters.dateFilter(scope.row.operatorTime)  }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="添加人">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-card>
  <el-dialog v-model="previewDialogShow">
    <el-row justify="center">
      <el-image v-for="(img, index) in srcList"
                :src="img" :preview-src-list="srcList"
                :key="index"></el-image>
    </el-row>
  </el-dialog>
  <el-dialog v-model="checkInfoDialog">
    <el-descriptions
      title="对账单明细查看"
      direction="vertical"
      :column="4"
      size="default"
      border
    >
      <el-descriptions-item label="媒体" :span="2">{{ currentCustomerName }}</el-descriptions-item>
      <el-descriptions-item label="充值笔数" :span="2">{{ currentOrderNum }}</el-descriptions-item>
      <el-descriptions-item label="账单金额" :span="2">{{ currentMoney }}</el-descriptions-item>
      <el-descriptions-item label="账单生成时间" :span="2">{{ $filters.dateFilter(currentTime) }}</el-descriptions-item>
    </el-descriptions>
    <el-row type="flex" justify="center" style="margin-top: 20px">
      <el-button type="primary" @click="handleDownLoad">下载详情</el-button>
    </el-row>
  </el-dialog>
  <pay-money-dialog v-model="payMoneyShow" :product-list="allProductList" @refreshDataList="getAll"></pay-money-dialog>
</template>

<script setup>
import { getAllStatement, getMediaRecordByIds, payMoney, updateBankReceipt } from '@/api/media'
import { getCurrentInstance, onMounted, ref } from 'vue'
import utils from '@/utils/utils'
import { getMediaProductAll } from '@/api/media-manager'
import store from '@/store'
import { STATEMENT_RELATIONS } from '@/utils/Export2ExcelConstants'
import { dateFormat } from '@/utils/date'
import { ElMessageBox } from 'element-plus'
import { searchApprovalContent } from '@/api/approval'
import { getUrls } from '@/utils/common'
import PayMoneyDialog from '@/views/media-pay-info/components/pay-money-dialog'
import { list } from '@/api/pay-info'

const total = ref(0)
const page = ref(1)
const size = ref(10)
const tableData = ref([])
const previewDialogShow = ref(false)
const payMoneyShow = ref(false)
const checkInfoDialog = ref(false)
const previewUrl = ref('')
let headers = {}

const allProductList = ref([])
const productList = ref([])
const getMediaProduct = async () => {
  const result = await getMediaProductAll()
  allProductList.value = result
  productList.value = transProductTypeToSelect(allProductList.value)
}
getMediaProduct()

const getProductInfoById = (productId) => {
  if (productId === undefined) {
    return
  }
  const result = productList.value.filter((item, index, self) => {
    return item.value === productId
  })
  if (result.length > 0) {
    return result[0].label
  } else {
    return ''
  }
}

const transProductTypeToSelect = (data) => {
  return data.map(item => {
    return {
      label: item.meidaType + '-' + item.proType + '-' + item.mediaPort,
      value: item.id
    }
  })
}

const getAll = async () => {
  const result = await list({
    page: page.value,
    size: size.value
  })
  total.value = result.total
  tableData.value = result.list
}
getAll()

/**
 * size 改变触发
 */
const handleSizeChange = currentSize => {
  size.value = currentSize
  getAll()
}
/**
 * 页码改变触发
 */
const handleCurrentChange = currentPage => {
  page.value = currentPage
  getAll()
}

const handleCheckBill = (id, money) => {
  ElMessageBox.confirm(
    '付款金额为: ' + money,
    '发起付款',
    {
      confirmButtonText: '确认付款',
      cancelButtonText: '取消',
      type: 'info'
    }
  ).then(async () => {
    await payMoney({
      id: id,
      type: 2,
      payMoney: 0
    })
  })
}

const saveSubmit = async () => {
  // if (result) {
  //   await getAll()
  //   utils.showSuccess('核销成功')
  // }
}

const currentCustomerName = ref('')
const currentOrderNum = ref(0)
const currentMoney = ref(0)
const currentTime = ref('')
const currentRecordList = ref([])
const excelName = ref('')
const handleViewAll = async (index, ids) => {
  const result = await getMediaRecordByIds({
    recordIds: ids
  })
  if (result.length > 0) {
    checkInfoDialog.value = true
    currentRecordList.value = result
    currentCustomerName.value = getProductInfoById(tableData.value[index].belongProductId)
    currentOrderNum.value = result.length
    currentMoney.value = tableData.value[index].totalMoney
    currentTime.value = tableData.value[index].operatorTime
    excelName.value = getProductInfoById(tableData.value[index].belongProductId) + Date.parse(new Date())
  }
}

const handleDownLoad = async () => {
  utils.showLoadding()
  const excel = await import('@/utils/Export2Excel')
  const data = formatJson(STATEMENT_RELATIONS, currentRecordList.value)
  excel.export_json_to_excel({
    // excel 表头
    header: Object.keys(STATEMENT_RELATIONS),
    // excel 数据（二维数组结构）
    data,
    // 文件名称
    filename: excelName.value,
    // 是否自动列宽
    autoWidth: true,
    // 文件类型
    bookType: 'xlsx'
  })
  utils.hideLoadding()
}

const formatJson = (headers, rows) => {
  // 首先遍历数组
  // [{ username: '张三'},{},{}]  => [[’张三'],[],[]]
  return rows.map(item => {
    return Object.keys(headers).map(key => {
      // 时间特殊处理
      if (headers[key] === 'recordTime') {
        return dateFormat(item[headers[key]])
      }
      return item[headers[key]]
    })
  })
}

const srcList = ref([])

const handleViewWaterBill = (url) => {
  srcList.value = getUrls(url)
  previewUrl.value = srcList.value[0]
  previewDialogShow.value = true
}

const handleAvatarSuccess = async (res, file, fileList, index, rowId) => {
  const result = await updateBankReceipt({
    id: rowId,
    bankReceipt: file.response.content.url
  })
  if (result) {
    await getAll()
    utils.showSuccess('上传水单成功')
  }
}

const handleRemove = (file, fileList, index) => {
  tableData.value[index].bankReceipt = ''
}

onMounted(() => {
  headers = { 'X-Token': store.getters.token }
})

const handleInsertClick = () => {
  payMoneyShow.value = true
}

</script>
